export const shouldShowDirectMessageButton = (
  isDirect: boolean,
  isCanSent: boolean
) => isDirect && isCanSent;
